import { FC } from "react";
import { Filter, SelectInput } from "react-admin";
import SearchWithQuery from "../../../../components/CustomSearch/SearchWithQuery";
import useCurrentUser from "../../../../hooks/useCurrentUser";
import { ordersReservationsCollRef } from "../../../../utils/referencies";

import { OrderStatus } from "../../types";

const filterOrderStatuses = [
  {
    id: OrderStatus.canceled,
    name: "Canceled",
  },
  {
    id: OrderStatus.delivered,
    name: "Delivered",
  },
  {
    id: OrderStatus.pending,
    name: "Pending",
  },
  {
    id: OrderStatus.preparing,
    name: "Preparing",
  },
  {
    id: OrderStatus.delivering,
    name: "Delivering",
  },
];

const OrdersFilters: FC<any> = (props) => {
  const { user } = useCurrentUser();

  return (
    <Filter {...props}>
      <SelectInput variant="outlined" source="status" label="Status" choices={filterOrderStatuses} />
      {user.id && (
        <SearchWithQuery query={ordersReservationsCollRef.where("brandId", "==", user.id)} source="code" label="Code" />
      )}
    </Filter>
  );
};

export default OrdersFilters;
